/**
 * @author       samuel@zumper.com (Samuel Shih)
 * @copyright    Copyright (c) 2019, Zumper
 * @description  LoadingFallback.jsx
 */

import { Box, type BoxProps, useColorModeValue, useTheme } from '@chakra-ui/react'
import type { ChakraZ4Type } from '@zcode-ui/chakra-themes'
import { ZumperLoader, type ZumperLoaderProps } from '@zcode-ui/loaders'
import React from 'react'
import StaticHydratingSection from '../../../shared/packages/static-hydrating-section/StaticHydratingSection'

interface Props extends Omit<BoxProps, 'as'> {
  name: string
}

const emptyProps: ZumperLoaderProps = {}

const StaticZumperLoader = ({ name }: { name: string }) => (
  <StaticHydratingSection
    component={ZumperLoader}
    forwardProps={emptyProps}
    initialLocationChanged={false}
    name={name}
  />
)

export const LoadingFallback = ({ children, className, id, name, ...rest }: Props) => {
  const { colors } = useTheme<ChakraZ4Type>()
  const textColor = useColorModeValue(colors.gray['800'], colors.gray['300'])
  return (
    <Box<'div'>
      display="flex"
      flexDir="column"
      alignItems="center"
      justifyContent="center"
      className={`${className ? ` ${className}` : ''}`}
      id={id}
      {...rest}
    >
      <StaticZumperLoader name={name} />
      <Box<'div'>
        color={textColor}
        fontFamily="body"
        fontSize="14px"
        mt={2}
      >{`One sec, gathering the ${name}`}</Box>
      {children}
    </Box>
  )
}
